export const SAP_COMMERCE_ASM_REQUEST_HEADER_NAME = 'sap-commerce-cloud-user-id';
